module.exports = __webpack_public_path__ + "static/media/easyGrey.f5bda8cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/img/easyGrey.svg
// module id = 217
// module chunks = 8